const API_BASE = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  ? "http://localhost:8000/api"
  : `${window.location.origin}/api`;

export async function fetchBarbers() {
  const res = await fetch(`${API_BASE}/barbers/`);
  if (!res.ok) throw new Error("Ustalar yüklenemedi");
  return res.json();
}

export async function fetchServices() {
  const res = await fetch(`${API_BASE}/services/`);
  if (!res.ok) throw new Error("Hizmetler yüklenemedi");
  return res.json();
}

export async function fetchBarberSchedule(barberId) {
  const res = await fetch(`${API_BASE}/barbers/${barberId}/schedule/`);
  if (!res.ok) throw new Error("Çalışma günleri yüklenemedi");
  return res.json();
}

export async function fetchAvailableSlots(barberId, dateStr) {
  const res = await fetch(`${API_BASE}/barbers/${barberId}/slots/${dateStr}/`);
  if (!res.ok) throw new Error("Müsait saatler yüklenemedi");
  return res.json();
}

export async function fetchSalonInfo() {
  const res = await fetch(`${API_BASE}/salon-info/`);
  if (!res.ok) throw new Error("Salon bilgileri yüklenemedi");
  return res.json();
}

export async function createAppointment(data) {
  const res = await fetch(`${API_BASE}/appointments/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(JSON.stringify(err));
  }
  return res.json();
}
